module.exports = __webpack_public_path__ + "static/media/vegas.8e83ab29.webp";